import React, { FC } from "react";
import VariantRightSection from "./variants/VariantRightSection";
import { inject, observer } from "mobx-react";
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import { ItemsStore, RolesAndPermissionStore } from "../../../../shared/store";
import {
  ProductItemModel,
  ProductVariantEditableModel,
} from "../../../../shared/models";
import {
  ItemDetailLeftPanel,
  ItemDetailRightPanel,
  MainOuterCard,
  VariantWrapper,
} from "../../../../shared/styles";
import VariantEditPopUp from "./variants/VariantEditPopUp";
import { VariantTable } from "./variants/Variant.styles";

type IProps = {
  productName: string;
  itemStore?: ItemsStore;
  onCloseVariantEditPopup: (refresh: boolean) => void;
  rolesAndPermissionStore: RolesAndPermissionStore;
};

const ProductVariantDetailMain: FC<IProps> = ({
  itemStore,
  productName,
  onCloseVariantEditPopup,
  rolesAndPermissionStore,
}) => {
  if (!itemStore?.selectedProduct?.variants) return null;
  const isModal = itemStore.selectedProduct.isEditVariant;
  const component = (
    <VariantWrapper>
      <FlexContainer padding={"10px 0px 0px"} className={"bg-white"}>
        <ItemDetailLeftPanel width={"40%"}>
          <MainOuterCard padding="20px" border={"none"}>
            <CustomLabel fontSize="20px" fontWeight="600" margin="0px 0px 30px">
              {productName}
            </CustomLabel>
            <VariantTable
              selectedVariantIndex={
                itemStore?.selectedProduct?.selectedVariantIndex || 0
              }
              variants={itemStore?.selectedProduct?.variants}
              onClick={(newIndex) => {
                const newProduct = new ProductItemModel({
                  ...itemStore.selectedProduct,
                  selectedVariantIndex: newIndex,
                  selectedVariant:
                    itemStore.selectedProduct?.variants?.options[newIndex],
                });
                newProduct.editableVariant =
                  ProductVariantEditableModel.init(newProduct);
                itemStore.updateSelectedProduct(newProduct);
              }}
            />
          </MainOuterCard>
        </ItemDetailLeftPanel>
        <ItemDetailRightPanel width={"60%"}>
          <VariantRightSection
            rolesAndPermissionStore={rolesAndPermissionStore}
          />
        </ItemDetailRightPanel>
      </FlexContainer>
    </VariantWrapper>
  );

  if (isModal) {
    return (
      <VariantEditPopUp
        itemStore={itemStore}
        onCloseVariantEditPopup={onCloseVariantEditPopup}
        productName={productName}
        rolesAndPermissionStore={rolesAndPermissionStore}
      />
    );
  }

  return component;
};

export default inject("itemStore")(observer(ProductVariantDetailMain));
